import { Bubble } from 'vue-chartjs'
import DefaultOptions from '../DefaultOptions'

export default Bubble.extend({
  props: ['data', 'options'],

  data () {
    return {
      defaultOptions: {

      }
    }
  },

  mounted () {
    setTimeout(() => { 
      let options = Object.assign({}, DefaultOptions, this.defaultOptions, this.options)
      this.renderChart(this.data, options)
    }, 600);    
  }
})



// WEBPACK FOOTER //
// ./src/components/vuestic-components/vuestic-chart/chart-types/BubbleChart.js